export const MIN_EXECUTION_DAYS_OUT = 20;
export const MAX_YEARS_OUT_TO_QUOTE = 1;
export const MIN_DURATION_DAYS = 30;
export const MAX_DURATION_MONTHS = 11;
